<template>
  <v-dialog v-model="visible" max-height="500" max-width="700">
    <v-card>
      <v-toolbar dense color="gray" dark>
        <v-toolbar-title class="title" justify="center">Neue Parasit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="form-content">
        <v-form @submit.prevent="submitForm">
          <v-row>
            <v-col cols="5">
              <label for="name:">Abkürzung</label>
              <v-text-field class="textFieldOne" outlined v-model="parasit.name" :rules="rules.name"></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="name:">Deutsch</label>
              <v-text-field class="textFieldTwo" outlined v-model="parasit.germanName"
                :rules="rules.germanName"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <label for="name:">Latein</label>
              <v-text-field class="textFieldThree" outlined v-model="parasit.latinName"
                :rules="rules.latinName"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-btn type="submit" class="emptyForm" style="margin-left: 95px; max-width: 360px; text-color: black"
              :loading="isLoading" :disabled="formSubmitted" color="primary">Erstellen
            </v-btn>
            <v-btn type="button" class="emptyForm" style="margin-left: 25px" :loading="isLoading" color="gray"
              :disabled="formSubmitted" @click="closeModal">Abbrechen</v-btn>
          </v-row>
        </v-form>
        <v-alert type="success" elevation="20" v-show="showAlert" :color="alertColor" class="alert">
          {{ alertText }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import UpdateParasit from "./UpdateParasit";

export default {
  formSubmitted: false,

  props: {
    parasit: {
      type: Object,
      default: () => ({ id: null, name: "", germanName: "", latinName: "" }),
    },
    visible: Boolean,
    itemList: Array,
  },
  data() {
    return {
      isLoading: false,
      dialog: false,
      showAlert: false,
      alertText: "",
      alertColor: "",
      rules: {
        name: [
          v => {
            if (!v) return true;
            if (v.length <= 4) {
              return true;
            } else {
              return "Die Abkürzung muss mindestens 4 Zeichen enthalten";
            }
          }
          // (v) => !!v || "Abkürzung ist erforderlich",
          // (v) =>
          //   (v && v.split("").length <= 4) ||
          //   "Die Abkürzung darf höchstens 4 Wörter umfassen",
        ],
        germanName: [v => !v || !!v || "Deutscher Name ist erforderlich"],
        latinName: [v => !v || !!v || "Lateinischer Name ist erforderlich"]
        // germanName: [(v) => !!v || "Deutscher Name ist erforderlich"],
        // latinName: [(v) => !!v || "Lateinischer Name ist erforderlich"],
      },
    };
  },
  computed: {
    formTitle() {
      return this.parasit && this.parasit.id
        ? "parasit bearbeiten"
        : "Neue parasit";
    },
    // validForm() {
    //   return (
    //     !!this.parasit.germanName &&
    //     !!this.parasit.latinName &&
    //     !!this.parasit.name
    //   );
    // }
  },
  components: {
    UpdateParasit,
  },
  methods: {
    closeModal() {
      this.formSubmitted = false;

      this.$emit("close");
    },
    showUpdateDialog() {
      this.dialog = true;
    },
    submitForm() {
      this.isLoading = true;

      const requestBody = {
        name: this.parasit.name,
        germanName: this.parasit.germanName,
        latinName: this.parasit.latinName,
      };

      if (!this.parasit.id) {
        axios
          .post(
            "/api/Parasit/Create",
            requestBody
          )
          .then((response) => {
            this.formSubmitted = true;
            this.isLoading = false;
            if (Array.isArray(this.itemList)) {
              this.$set(this.itemList, this.itemList.length, response.data);
            } else {
              this.itemList = [response.data];
            }
            if (response.status === 200) {
              this.showAlert = true;
              this.alertColor = "success";
              this.alertText = "Das neue Parasit wurde erfolgreich erstellt";
              this.$emit("updated-table", true);
              setTimeout(() => {
                this.closeModal();
                this.showAlert = false;
              }, 2000);
            }
          })
          .catch((error) => {
            console.log(error);
            this.showAlert = true;
            this.isLoading = false;
            this.alertColor = "error";
            this.alertText = "Fehler beim Erstellen der Parasit";
            setTimeout(() => {
              this.showAlert = false;
            }, 2000);
          });
      }
    },
  },
};
</script>
<style>
.alert {
  position: fixed !important;
  width: 100% !important;
  max-width: 784px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  padding: 40px 100px !important;
}

.form-content {
  margin-top: 60px;
}
</style>
